// extracted by mini-css-extract-plugin
export default {"selected-account":"rSEdg","information":"nzSQR","selected-account_faded":"t16Xk"};